import RootRoute from './routes/RootRoute';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div data-testid={'App'}>
      <RootRoute />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
